
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Plus } from "lucide-react"

import { Button } from "@/components/ui/button"
import { AppointmentCalendar } from "@/components/appointments/appointment-calendar"
import { AddAppointmentDialog } from "@/components/appointments/add-appointment-dialog"

export default function AppointmentsPage() {
  const { t } = useTranslation()
  const [isAddAppointmentOpen, setIsAddAppointmentOpen] = useState(false)

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-3xl font-bold tracking-tight">{t("appointments.title")}</h2>
        <Button onClick={() => setIsAddAppointmentOpen(true)}>
          <Plus className="mr-2 h-4 w-4" />
          {t("appointments.addAppointment")}
        </Button>
      </div>
      <AppointmentCalendar />
      <AddAppointmentDialog open={isAddAppointmentOpen} onOpenChange={setIsAddAppointmentOpen} />
    </div>
  )
}
